import { authHeader } from './auth-header';
import { apiconfig } from './apiconfig';
import axios from "axios";
/* eslint-disable no-console */

export const services = {
    restApi,
    restApiOld,
    restStore,
    restActionApi,
    restCustomApi,
    appendIDParam
};

function restStore(action, method, body = {}, header = null, version = 'v1') {

    let config = {
        method,
        url: `${apiconfig.getAPIPath()}/api/${version}/${action}`,
        headers: header == null ? authHeader() : header,
        data: body
    };

    //console.log("AAAA", apiconfig.getAPIPath());


    // if(method.toLowerCase() !== 'get') {
    //     config['data'] = action == 'login' ? body : JSON.stringify(body);
    // }

    return axios(config).then(handleResponse).catch(e => {
        handleUnauthorized(e.response);
      });
}

function restApi(action, method, body = {}, header = null, version = 'v1') {

    let api_server = apiconfig.getAPIUri(); //JSON.parse(localStorage.getItem('client'));

    // console.log(api_server);

    let config = {
        method,
        url: `${api_server}/api/${version}/${action}`,
        headers: header == null ? authHeader() : header,
        data: body
    };
    
    // if(method.toLowerCase() !== 'get') {
    //     config['data'] = action == 'login' ? body : JSON.stringify(body);
    // }

    //console.log(JSON.stringify(config));

    return axios(config).then(handleResponse).catch(e => {
        handleUnauthorized(e.response);
      });
}

function restApiOld(action, method, body = {}, header = null, version = 'v1') {

    let api_server = JSON.parse(localStorage.getItem('client'));
    let config = {
        method,
        url: `${api_server.api}/api/${version}/${action}`,
        headers: header == null ? authHeader() : header,
        data: body
    };
    
    // if(method.toLowerCase() !== 'get') {
    //     config['data'] = action == 'login' ? body : JSON.stringify(body);
    // }

    //console.log(JSON.stringify(config));

    return axios(config).then(handleResponse).catch(e => {
        handleUnauthorized(e.response);
      });
}

function restActionApi(action, method, body = {}, header = null, version = 'v1') {

    let api_server = JSON.parse(localStorage.getItem('client'));
    let config = {
        method,
        url: `${api_server.api}/api/${version}/${action}`,
        headers: header == null ? authHeader() : header,
        data: JSON.stringify(body)
    };

    // if(method.toLowerCase() !== 'get') {
    //     config['data'] = action == 'login' ? body : JSON.stringify(body);
    // }

    return axios(config).then(handleResponse).catch(e => {
        handleUnauthorized(e.response);
      });
}

function restCustomApi(url) {
    
    let config = {
        method: 'get',
        url,
        headers: authHeader()
    };

    return axios(config).then(handleResponse).catch(e => {
        handleUnauthorized(e.response);
      });
}

function appendIDParam(ids, param) {

    let jsonParam = {};
    let jsonId = `{ "conjuction": "and", "${ids['name']}": { "value": ${ids['value']} } }`;
    let objId = JSON.parse(jsonId);

    if(param == '') {

        let clause = [objId];
        jsonParam['clause'] = clause;

    } else {

        jsonParam = JSON.parse(param);
        jsonParam['clause'].push(JSON.parse(jsonId));        
    }

    return JSON.stringify(jsonParam);

}

function handleResponse(response) {

    if (response.status == 401) {
        localStorage.removeItem('user');
        location.reload(true);

        const error = (response.data && response.data.message) || response.statusText;
        return Promise.reject(error);

    } else {
        return response.data;
    }
}

function handleUnauthorized(response) {
    if(response.status == 401) {
        console.log(response.statusText);
        localStorage.removeItem('user');
        location.reload(true);

        const error = (response.data && response.data.message) || response.statusText;
        return Promise.reject(error);

    }
}